import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';

import { http } from '@loyalup/core';
import { Button } from '@loyalup/ui';

import s from './Agreement.module.css';

const Agreement = ({ match }) => {
  const [data, setData] = useState(null);

  const { sid } = match.params;

  useEffect(() => {
    (async () => {
      const { website_url: websiteUrl, name } = await http('GET', '/signup/' + sid);
      setData({ websiteUrl, name });
    })();
  }, [sid]);

  if (!data) return null;

  return (
    <div className={s.root}>
      <div className={s.page}>
        <h1>ДОГОВОР-ОФЕРТА</h1>
        <h2>Правила участия в программе лояльности «{data?.name}»</h2>
        <h3>Общие положения</h3>
        <p>
          Настоящий Договор определяет условия участия в программе лояльности «{data?.name}» на территории России.
          Получая электронную карту для вступления в Клуб, Участник подтверждает полное принятие настоящих Правил и
          обязуется их выполнять.
        </p>
        <p>
          Участник Программы получает вознаграждения и дополнительные привилегии при приобретении товаров и/или услуг в
          сети Партнеров.
          {data?.websiteUrl && (
            <span> Полный список и размер поощрений опубликован на Интернет-сайте Клуба - {data?.websiteUrl}.</span>
          )}
        </p>
        <ol className={s.list}>
          <li>
            <b>Термины клуба</b>
            <ol className={s.list}>
              <li>
                <b>Договор (Договор-оферта, Правила)</b> – Правила участия в программе лояльности «{data?.name}».
              </li>
              <li>
                <b>Клуб (Программа)</b> - бонусная программа лояльности «{data?.name}» для лучших клиентов Организатора.
              </li>
              <li>
                <b>Организатор</b> – {data?.name}, обладающее исключительными правами по управлению и развитию
                Программы, являющееся ответственной стороной всех сделок по накоплению и расходованию Бонусов в
                Программе.
              </li>
              <li>
                <b>Участник</b> – физическое лицо, достигшее 18 лет, участник Программы, заключившее Договор с
                Организатором об участии в программе лояльности.
              </li>
              <li>
                <b>Карта Клуба</b> – электронная карта для приложения Wallet, по которой Участник может накапливать и
                расходовать Бонусы, совершая покупки у Организатора.
              </li>
              <li>
                <b>Бонусы</b> – условные расчетные единицы, применяемые в рамках Клуба.
              </li>
              <li>
                <b>Анкета</b> – форма предоставления Участником Программы персональной информации.
              </li>
              <li>
                <b>Промо-карта (Промо-купон, Купон)</b> – электронный купон для приложения Wallet, по которому Участник
                может получить вознаграждение и/или дополнительные привилегии при приобретении товаров и/или услуг у
                Организатора в соответствии с условиями, указанными в электронном купоне
                {data?.websiteUrl && ` и/или на Интернет-сайте - ${data?.websiteUrl}`}.
              </li>
              {data?.websiteUrl && (
                <li>
                  <b>Интернет-сайт Клуба (Сайт)</b> – {data?.websiteUrl}.
                </li>
              )}
            </ol>
          </li>
          <li>
            <b>Участие</b>
            <ol className={s.list}>
              <li>
                Участниками Программы могут быть только физические лица, достигшие восемнадцати лет. На данные лица
                будет распространяться действие настоящих Правил со всеми периодически вносимыми в них изменениями, с
                момента заключения Договора в соответствии с п. 2.2. настоящего Договора.
              </li>
              <li>
                Участник считается заключившим Договор (акцептовавшим Договор-оферту) с момента создания Карты Клуба.
              </li>
              <li>Активация карты производится в момент установки карты в смартфон.</li>
              <li>
                Организатор вправе отказать Клиенту в участии в Клубе в случае отсутствия технической или иной
                возможности на момент обращения.
              </li>
            </ol>
          </li>
          <li>
            <b>Начисление Бонусов</b>
            <ol className={s.list}>
              <li>
                Для начисления Бонусов Участник должен уведомить Организатора непосредственно перед совершением покупки
                или получением услуги о том, что данная покупка или приобретение услуги являются сделкой в рамках
                Программы, путем предъявления своей Карты Клуба на кассовом терминале. Организатор не несет
                ответственности за не начисление Бонусов в том случае, если Участник не известил о том, что сделка
                осуществляется в рамках Программы.
              </li>
              <li>
                Начисление Бонусов производится при любой форме оплаты (наличными, дебетовой картой, кредитной картой)
                при предоставлении Карты Клуба на терминале.
              </li>
              <li>
                Для накопления большего количества Бонусов Участник может принимать участие в локальных Акциях
                Организатора. Условия по текущим Акциям и размеры вознаграждений (Бонусов) публикуются на Сайте Клуба.
              </li>
              <li>
                Бонусы и права, предоставленные Участнику, Участником не могут быть проданы, переданы, уступлены другому
                лицу или использованы, кроме как в соответствии с настоящими Правилами.
              </li>
            </ol>
          </li>
          <li>
            <b>Расходование Бонусов</b>
            <ol className={s.list}>
              <li>
                Для расходования Бонусов Участник должен уведомить Организатора непосредственно перед совершением
                покупки или получением услуги о том, что данная покупка или приобретение услуги являются сделкой в
                рамках Программы, путем предъявления Карты Клуба на кассовом терминале.
              </li>
              <li>
                Бонусы могут быть использованы только для приобретения товаров и/или услуг, реализуемых Организатором.
              </li>
              <li>При покупке нельзя суммарно расплатиться Бонусами по двум и более картам Клуба.</li>
            </ol>
          </li>
          <li>
            <b>Замена и Восстановление Карты Участника</b>
            <ol className={s.list}>
              <li>
                Восстановление по Картам Клуба возможно только в том случае, если Участником была заполнена Анкета.
                Участник может обратиться в одну из торговых точек, список которых указан на Сайте Клуба, и получить
                новую карту с переносом Бонусов со старой Карты. Все данные старой Карты будут доступны на новой Карте
                сразу после выдачи новой Карты.
              </li>
            </ol>
          </li>
          <li>
            <b>Баланс Карты</b>
            <ol className={s.list}>
              <li>
                Участник может проверить баланс своей Карты следующими способами:
                <ul>
                  <li>открыть Карту Клуба в приложении Wallet;</li>
                  <li>обратится в торговую точку Организатора.</li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <b>Участие в Акциях</b>
            <ol className={s.list}>
              <li>
                Для участия в Акциях в соответствии с Правилами необходимо предъявить Карту Клуба кассиру перед
                оформлением покупки или получением услуги у Организатора.
              </li>
              <li>
                О проходящих Акциях и персональных предложениях Участник может узнать:
                <ul>
                  <li>в Карте Клуба в приложении Wallet;</li>
                  <li>на Интернет-сайте Клуба;</li>
                  <li>в Контакт-центре Клуба;</li>
                  <li>через информационную PUSH рассылку.</li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <b>Иные условия</b>
            <ol className={s.list}>
              <li>
                Анкетные данные Участника хранятся у Организатора в течение 3 (трех) лет с момента прекращения его
                участия в Клубе. По истечении этого срока анкетные данные уничтожаются.
              </li>
              <li>
                Участники, принимающие участие в специальных предложениях и Акциях Программы, должны ознакомиться с
                правилами данных предложений и Акций на Интернет-сайте и следовать им.
              </li>
              <li>
                Организатор по своему усмотрению вправе вносить любые изменения в настоящие Правила в любое время.
                Информация об указанных изменениях будет размещаться на Интернет-сайте Клуба.
              </li>
              <li>
                Организатор вправе вносить любые изменения в любое время без предварительного уведомления и
                исключительно по его усмотрению в перечень товаров, работ и услуг, в отношении которых начисляются
                Бонусы.
              </li>
              <li>
                Организатор оставляет за собой право приостановить или прекратить Программу в любое время с уведомлением
                Участника за один месяц. Организатор не несет ответственности за приостановку или прекращение Программы
                в отношении любого Счета Участника, включая, но, не ограничиваясь, ответственностью за Бонусы на Счете
                Участника в момент приостановки или прекращения Программы.
              </li>
              <li>
                Уведомление считается сделанным от имени Организатора Участнику, если оно отправлено на почтовый или
                электронный адрес Участника, а также если оно сделано по телефону или по sms на номера, а также в виде
                PUSH-уведомления, отправленного на Карту Клуба, указанные в Анкете, или размещено на Интернет-сайте
                Клуба.
              </li>
              <li>
                Организатор вправе прекратить участие в Программе любого Участника без уведомления в случаях, если
                Участник:
                <ul>
                  <li>не соблюдает настоящие Правила;</li>
                  <li>
                    В случае прекращения участия по указанным выше основаниям Бонусы данного Участника поступают в доход
                    Организатора.
                  </li>
                </ul>
              </li>
              <li>
                Участник вправе прекратить свое участие в Программе в любое время путем направления Организатору
                письменного уведомления о прекращении участия (на почтовый или электронный адрес Организатора). После
                получения уведомления Организатором членство Участника в Программе прекращается, а Бонусы поступают в
                доход Организатора.
              </li>
              <li>
                Карта Клуба действительна в течение срока действия Программы или до любой другой даты прекращения
                действия Карт Клуба согласно настоящим Правилам участия.
              </li>
              <li>
                В случае если спор между Организатором и Участником не может быть разрешен в соответствии с настоящими
                Правилами, он разрешается в соответствии с действующим законодательством Российской Федерации.
              </li>
              <li>
                По всем вопросам, связанным с участием Участников в Программе, следует обращаться в Контакт-центр.
                Ответы на вопросы Участников будут даны в день обращения. В случае, когда ответ на вопрос требует
                проведения Организатором дополнительной проверки, такой срок может быть увеличен до 30 (тридцати) дней.
              </li>
            </ol>
          </li>
          <li>
            <b>Ответственность</b>
            <ol className={s.list}>
              <li>
                Организатор не несет ответственности за сохранность Бонусов, в случае утери Карты Участником или ее
                кражи третьими лицами.
              </li>
              <li>
                Ответственность Организатора в отношении предоставляемых в рамках Программы товаров и услуг и
                соответствующие гарантийные обязательства ограничены требованиями законодательства Российской Федерации.
              </li>
            </ol>
          </li>
        </ol>
        <div className={cn(s.button, s.noPrint)}>
          <Button fixedWidth={220} center onClick={() => window.close()}>
            Закрыть соглашение
          </Button>
          <Button fixedWidth={220} center theme="black" onClick={() => window.print()}>
            Печать
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Agreement);
